import { render } from "./PortableTable.vue?vue&type=template&id=3a346f8b&scoped=true"
import script from "./PortableTable.vue?vue&type=script&lang=js"
export * from "./PortableTable.vue?vue&type=script&lang=js"

import "./PortableTable.vue?vue&type=style&index=0&id=3a346f8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a346f8b"]])

export default __exports__